import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { gbp } from "@/components/whatsapp/WaCostsTab";

const ROWS = [["Recipients", (s) => s.recipients], ["Delivery rate", (s) => `${s.rates.delivery}%`], ["Read-receipt rate", (s) => `${s.rates.read_receipt}%`],
  ["Click rate", (s) => `${s.rates.click}%`], ["Reply rate", (s) => `${s.rates.reply}%`], ["Unique clicks", (s) => s.unique_clicks],
  ["Replies", (s) => s.replies], ["Failed", (s) => s.failed], ["Cost ex VAT", (s) => gbp(s.cost.actual_ex_vat)],
  ["Cost per click", (s) => (s.cost_per_click != null ? gbp(s.cost_per_click) : "—")], ["Cost per reply", (s) => (s.cost_per_reply != null ? gbp(s.cost_per_reply) : "—")],
  ["Enquiries (confirmed + probable)", (s) => `${s.attribution.confirmed.enquiries} + ${s.attribution.probable.enquiries}`],
  ["Sales (confirmed + probable)", (s) => `${s.attribution.confirmed.sales} + ${s.attribution.probable.sales}`],
  ["Sales value inc VAT", (s) => gbp(s.attribution.confirmed.sales_value + s.attribution.probable.sales_value)],
  ["Cost per enquiry", (s) => (s.cost_per_enquiry != null ? gbp(s.cost_per_enquiry) : "—")], ["Cost per sale", (s) => (s.cost_per_sale != null ? gbp(s.cost_per_sale) : "—")]];

export function WaReportsTab() {
  const [camps, setCamps] = useState([]);
  const [pick, setPick] = useState([]);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/wa/campaigns").then((r) => setCamps(r.data.items)).catch(() => {}); }, []);
  const toggle = (id) => setPick(pick.includes(id) ? pick.filter((x) => x !== id) : pick.length < 6 ? [...pick, id] : pick);
  const run = async () => { try { setRes((await api.get("/wa/analytics/compare", { params: { ids: pick.join(",") } })).data.items); } catch (e) { toast.error(e.response?.data?.detail || "Could not compare"); } };
  return (
    <div className="space-y-5">
      <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="wa-reports-pick">
        <h2 className="text-sm font-bold text-slate-900 mb-1">Compare campaigns</h2>
        <p className="text-xs text-slate-500 mb-3">Choose 2 to 6 campaigns.</p>
        <div className="flex flex-wrap gap-1.5">
          {camps.map((c) => (
            <button key={c.id} onClick={() => toggle(c.id)} data-testid={`wa-reports-pick-${c.id}`}
              className={`text-xs rounded-full px-2.5 py-1 border cursor-pointer ${pick.includes(c.id) ? "bg-indigo-600 text-white border-indigo-600" : "border-slate-200 text-slate-600"}`}>{c.name}</button>
          ))}
          {!camps.length && <span className="text-sm text-slate-400">No campaigns yet.</span>}
        </div>
        <Button className="mt-3 bg-indigo-600 hover:bg-indigo-700 text-white" disabled={pick.length < 2} onClick={run} data-testid="wa-reports-compare">Compare</Button>
      </section>
      {res && (
        <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 overflow-x-auto" data-testid="wa-reports-table">
          <table className="w-full text-sm">
            <thead><tr><th />{res.map((s) => <th key={s.campaign_id} className="text-left font-semibold text-slate-800 px-3 py-1">{s.name}{s.simulated ? " (test)" : ""}</th>)}</tr></thead>
            <tbody>
              {ROWS.map(([label, fn]) => (
                <tr key={label} className="border-t border-slate-100">
                  <td className="py-1.5 text-xs text-slate-500 whitespace-nowrap">{label}</td>
                  {res.map((s) => <td key={s.campaign_id} className="px-3" data-testid={`wa-reports-cell-${label.toLowerCase().replace(/\s+/g, "-")}-${s.campaign_id}`}>{fn(s)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </div>
  );
}

export function WaLinkDomainsCard({ canEdit }) {
  const [v, setV] = useState("");
  useEffect(() => { api.get("/wa/link-domains").then((r) => setV(r.data.domains.join(", "))).catch(() => {}); }, []);
  const save = async () => {
    try { const r = await api.put("/wa/link-domains", { domains: v.split(",").map((x) => x.trim()).filter(Boolean) }); setV(r.data.domains.join(", ")); toast.success("Link domains saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="wa-link-domains-card">
      <h2 className="text-sm font-bold text-slate-900 mb-1">Approved link domains</h2>
      <p className="text-xs text-slate-500 mb-3">Campaign tracked links can only point to these websites (subdomains included).</p>
      <div className="flex gap-2">
        <Input value={v} disabled={!canEdit} onChange={(e) => setV(e.target.value)} placeholder="e.g. hottubsuperstore.co.uk" data-testid="wa-link-domains-input" />
        {canEdit && <Button variant="outline" onClick={save} data-testid="wa-link-domains-save">Save</Button>}
      </div>
    </section>
  );
}
